module.exports = __webpack_public_path__ + "static/media/choithramsPepsi.992d64b2.png";